import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function CertificatesIcon() {
  const isDark = useAppSelector(isDarkTheme)
  return (
    <svg width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M17.625 6.125V9.625' stroke={isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'} strokeWidth='1.25' />
      <path
        d='M11.125 17.625H1.625C1.07272 17.625 0.625 17.1773 0.625 16.625V1.625C0.625 1.07272 1.07272 0.625 1.625 0.625H8.125H12.625'
        stroke={isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'}
        strokeWidth='1.25'
      />
      <path
        d='M12.625 0.625V4.625C12.625 5.72957 13.5204 6.625 14.625 6.625H17.625'
        stroke={isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'}
        strokeWidth='1.25'
        strokeLinecap='round'
      />
      <path
        d='M12.625 0.625L17.625 6.125'
        stroke={isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'}
        strokeWidth='1.25'
        strokeLinecap='round'
      />
      <path
        d='M14.625 9.625L10.625 10.975V13.7155C10.625 15.988 12.33 18.1075 14.625 18.625C16.92 18.1075 18.625 15.988 18.625 13.7155V10.975L14.625 9.625ZM17.625 13.7155C17.625 15.5155 16.35 17.1805 14.625 17.689C12.9 17.1805 11.625 15.52 11.625 13.7155V11.6005L14.625 10.588L17.625 11.6005V13.7155Z'
        fill={isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'}
      />
      <path
        d='M12.8252 14.625L13.8252 15.625L16.8252 12.625'
        stroke={isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'}
        strokeLinecap='square'
      />
    </svg>
  )
}
